import { type Dispatch, type SetStateAction, useEffect, useState } from 'react'

import { type PimProductV11 } from '@redteclab/api/clients/bully'

import { type AlgoliaProxyRecord } from '../../../algolia'

export const useProductQuantitySelectionControls = ({
  currentVariant,
}: {
  currentVariant: AlgoliaProxyRecord | PimProductV11
}): {
  quantity: number
  setQuantity: Dispatch<SetStateAction<number>>
} => {
  const [quantity, setQuantity] = useState(1)

  useEffect(() => {
    setQuantity(1)
  }, [currentVariant.upid])

  return {
    quantity,
    setQuantity,
  }
}
